import styled from 'styled-components';
import { Box } from '@rsos/components/capstone/base';

const INBOUND_TABLE_HEIGHT = 44;

export const InboundPageContainer = styled(Box).attrs({
  justify: 'start',
  position: 'relative',
})``;

export const Container = styled(Box).attrs(({ theme }) => ({
  justify: 'start',
  border: `1px solid ${theme.colors.heavyLineOutline}`,
  borderRadius: '5px',
  height: 347,
}))`
  overflow-x: hidden;
  overflow-y: auto;
`;
export const EmptyContainer = styled(Box).attrs(() => ({
  justify: 'center',
  align: 'center',
}))``;

export const TimeStampContainer = styled(Box).attrs(() => ({
  width: '100%',
  justify: 'space-between',
  align: 'center',
  horizontal: true,
}))``;

export const ViewOrEdit = styled(Box).attrs(() => ({
  justify: 'center',
  align: 'center',
  horizontal: true,
}))`
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.colors.lightLineDivider};
  }
`;

const BaseRow = styled.div`
  display: grid;
  border-collapse: collapse;
  grid-template-columns: 1fr 0.6fr 1.4fr;
`;

export const InboundTable = styled.div`
  display: block;
  height: calc(100% - ${INBOUND_TABLE_HEIGHT}px);
`;

export const InboundTHead = styled(BaseRow)`
  min-width: 100%;
  height: ${INBOUND_TABLE_HEIGHT}px;
  align-items: center;
  z-index: 1;
  position: sticky;
  top: 0;
  background-color: ${({ theme }) => theme.colors.background};
  z-index: 2;
  border-bottom: 1px solid ${({ theme }) => theme.colors.heavyLineOutline};
`;

export const InboundTRow = styled(BaseRow)`
  background-color: ${({ background, theme }) =>
    background ? theme.colors.background : theme.colors.foreground};
  min-height: 35px;
`;

export const InboundTData = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: ${({ flexEnd }) => (flexEnd ? 'flex-end' : 'flex-start')};
  align-items: center;
  padding: 5px 10px;
  line-height: 14px;
  letter-spacing: 0.24px;
  font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : 700)};
  font-size: 12px;
  color: ${({ theme, color }) => (color ? color : theme.colors.secondaryText)};
  background-color: transparent;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-left: ${p => (p.indent ? '12px' : 'unset')};
`;

export const TooltipChild = styled(Box).attrs(() => ({
  position: 'absolute',
  color: 'background',
  bg: 'primaryText',
  borderRadius: '5px',
  p: '10px',
}))`
  display: none;
  white-space: nowrap;
  right: 0;
  top: 110%;
`;

export const CustomToolTip = styled(Box).attrs(() => ({
  position: 'relative',
}))`
  &:hover ${TooltipChild} {
    display: ${p => (p.isVisible ? 'flex' : 'none')};
  }
`;
